import { SEND_YARN, GET_SEND_YARN } from "../../Action/Sizer/sendYarn";

const initialState = {
  sendyarn: [],
};

function sendYarn(state = initialState, action) {
  switch (action.type) {
    case SEND_YARN: {
      return { ...state, sendyarn: [action.payload, ...state.sendyarn] };
    }
    case GET_SEND_YARN: {
      return { ...state, sendyarn: action.payload };
    }
    default:
      return state;
  }
}

export default sendYarn;
